@if (billOfLadingInfo && hhgBillOfLadingReview$ | async) {
  <ng-container [formGroup]="billOfLadingInfo">
    <div class="grid-row grid-gap-1">
      <legend class="usa-legend usa-legend--medium">Employee Information</legend>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="employeeFirstName" class="usa-label">Relocating Employee's First Name</label>
        <input type="text" class="usa-input maxw-full" id="employeeFirstName" formControlName="employeeFirstName" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="employeeMiddleInitial" class="usa-label">Middle Initial</label>
        <input type="text" class="usa-input maxw-full" id="employeeMiddleInitial" formControlName="employeeMiddleInitial" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="employeeLastName" class="usa-label">Last Name</label>
        <input type="text" class="usa-input maxw-full" id="employeeLastName" formControlName="employeeLastName" readonly="true" />
      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <legend class="usa-legend usa-legend--medium">TSP Information</legend>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="tspName" class="usa-label">Name</label>
        <input type="text" class="usa-input maxw-full" id="tspName" formControlName="tspName" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="scac" class="usa-label">SCAC</label>
        <input type="text" class="usa-input maxw-full" id="scac" formControlName="scac" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="dunsNumber" class="usa-label">
          DUNS Number
        </label>
        <input type="text" class="usa-input maxw-full" id="dunsNumber" formControlName="dunsNumber" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="assignedAgent" class="usa-label">
          TSP Contact
        </label>
        <input type="text" class="usa-input maxw-full" id="assignedAgent" formControlName="assignedAgent" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="email" class="usa-label">
          Email
        </label>
        <input type="text" class="usa-input maxw-full" id="email" formControlName="email" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="phone" class="usa-label">
          Phone
        </label>
        <input type="text" class="usa-input maxw-full" id="phone" formControlName="phone" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="phoneExt" class="usa-label">
          Phone Ext
        </label>
        <input type="text" class="usa-input maxw-full" id="phoneExt" [maxlength]="10" formControlName="phoneExt" readonly="true" />
      </div>
    </div>
    <div class="grid-row grid-gap-1">
      <legend class="usa-legend usa-legend--medium">Other Information</legend>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="moveDate" class="usa-label">
          Pickup/Move Date
        </label>
        <input type="text" class="usa-input maxw-full" id="moveDate" formControlName="moveDateFormatted" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="requestedPackDate" class="usa-label">Requested Packing Date</label>
        <input type="text" class="usa-input maxw-full" id="requestedPackDate" formControlName="requestedPackDateFormatted" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="requiredDeliveryDate" class="usa-label">
          Requested Delivery Date
        </label>
        <input type="text" class="usa-input maxw-full" id="requiredDeliveryDate" formControlName="requiredDeliveryDateFormatted" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="specialRate" class="usa-label">
          Tariff/Tender/Special Rate Authority
        </label>
        <input type="text" class="usa-input maxw-full" id="specialRate" formControlName="specialRate" readonly="true" />
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="packageWeight" class="usa-label">
          Estimated Weight
        </label>
        <input type="text" class="usa-input maxw-full" id="packageWeight" formControlName="weight" readonly="true" />
      </div>
      @if (hhgBillOfLadingDetail$ | async) {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" formGroupName="bolDetails">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="authorityForShipment" class="usa-label">Authority For Shipment (Travel Order No.)
                <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input type="text" id="authorityForShipment" class="usa-input maxw-full" maxlength="15" formControlName="travelOrderNumber" />
              @if (this.billOfLadingInfo.get('bolDetails').get('travelOrderNumber').invalid && (this.billOfLadingInfo.get('bolDetails').get('travelOrderNumber').touched || this.billOfLadingInfo.get('bolDetails').get('travelOrderNumber').dirty)) {
                <div class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>TravelOrder Number is required
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="travelOrderDate" class="usa-label">Travel Order Date
                <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
              </label>
              <input type="text" id="travelOrderDate" class="usa-input maxw-full" formControlName="travelOrderDateFormated" name="moveDate" placeholder="mm/dd/yyyy" bsDatepicker placement="right" placeholder="Travel Order Date" />
              @if (this.billOfLadingInfo.get('bolDetails').get('travelOrderDateFormated').invalid && (this.billOfLadingInfo.get('bolDetails').get('travelOrderDateFormated').touched || this.billOfLadingInfo.get('bolDetails').get('travelOrderDateFormated').dirty)) {
                <div class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg>TravelOrder Date is required
                </div>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="agencyShipmentId" class="usa-label">Agency Shipment ID No.</label>
              <input type="text" id="agencyShipmentId" class="usa-input maxw-full" maxlength="18" formControlName="agencyShipmentIdNo" />
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="tspProBillNo" class="usa-label">TSP Pro Bill No.</label>
              <input type="text" id="tspProBillNo" class="usa-input maxw-full" formControlName="tspProBillNo" [maxlength]="22" />
            </div>
            @if (isHhgShipmentType === true) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="hhgAppropriation" class="usa-label">HHG Appropriation Chargeable <abbr title="required" class="usa-hint usa-hint--required">*</abbr> : </label>
                <input type="text" id="hhgAppropriation" class="usa-input maxw-full" formControlName="appropriationChargeCode" [maxlength]="48" />
                @if (this.billOfLadingInfo.get('bolDetails').get('appropriationChargeCode').invalid && (this.billOfLadingInfo.get('bolDetails').get('appropriationChargeCode').touched || this.billOfLadingInfo.get('bolDetails').get('appropriationChargeCode').dirty)) {
                  <div class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Appropriation Charge Code is required
                  </div>
                }
              </div>
            }
            @if (isHhgShipmentType === true) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="otherHhgAppropriation" class="usa-label">Other HHG Appropriation Chargeable</label>
                <input type="text" id="otherHhgAppropriation" class="usa-input maxw-full" formControlName="otherAppropriationChargeCode" [maxlength]="48" />
              </div>
            }
            @if (isUABShipmentType === true) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="uabAppropriationChargeCode" class="usa-label">UAB Appropriation Chargeable</label>
                <input type="text" id="uabAppropriationChargeCode" class="usa-input maxw-full" formControlName="uabAppropriationChargeCode" [maxlength]="48" />
              </div>
            }
            @if (isUABShipmentType === true) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="otherUabAppropriationChargeCode" class="usa-label">Other UAB Appropriation Chargeable</label>
                <input type="text" id="otherUabAppropriationChargeCode" class="usa-input maxw-full" formControlName="otherUabAppropriationChargeCode" [maxlength]="48" />
              </div>
            }
            @if (isPOVShipmentType === true) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="povAppropriationChargeCode" class="usa-label">POV Appropriation Chargeable</label>
                <input type="text" id="povAppropriationChargeCode" class="usa-input maxw-full" formControlName="povAppropriationChargeCode" />
              </div>
            }
            @if (isPOVShipmentType === true) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="otherPOVAppropriation" class="usa-label">Other POV Appropriation Chargeable</label>
                <input type="text" id="otherPOVAppropriation" class="maxw-full usa-input" formControlName="otherPovAppropriationChargeCode" />
              </div>
            }
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="selectBtn2" class="usa-label">Verify origin, destination & other addresses:</label>
              <button id="selectBtn2" type="button" (click)="openAddressVerfiicationDialog()" class="usa-button">Addresses</button>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-container>
}
